import { StyleSheet, View, ActivityIndicator } from 'react-native';
import React, { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { navStack } from '../../Types/uitypes';
import { User } from '../../Types/modeltypes';

export default function SplashScreen() {
    const navigation = useNavigation<navStack>();

    function getCsrfToken(): string | null {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute("content") : null;
    }

    const csrf = getCsrfToken();

    useEffect(() => {
        const init = async () => {
            try {
                const response = await fetch('/me', {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        "X-CSRF-TOKEN": csrf || ""
                    },
                    credentials: 'include', // send session cookie
                });

                if (!response.ok) {
                    // Not logged in
                    navigation.navigate("LoginScreen");
                    return;
                }

                const data = await response.json();

                const user: User = {
                    id: data.user.id,
                    name: data.user.name,
                    email: data.user.email,
                    email_verified_at: data.user.email_verified_at,
                    created_at: data.user.created_at,
                    updated_at: data.user.updated_at,
                };

                navigation.navigate("CoupansScreen", { user });

            } catch (error) {
                console.error('Error checking user:', error);
                navigation.navigate("LoginScreen");
            }
        };

        init();
    }, []);

    return (
        <View style={styles.container}>
            <ActivityIndicator size="large" color="#007AFF" />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // optional
    },
});